module.exports = __webpack_public_path__ + "images/logo_mini.png?e54b10fda1d873640b48b26892b5521a";